const setToggleableJsonResume = (resume) => ({
    type: 'SET_TOGGLEABLE_JSON_RESUME',
    resume,
});

export default setToggleableJsonResume;
